'use strict';

// ES6 class definition
export default class Searchsolr {
    
    constructor() {
        let self = this;

        if (!document.querySelector('.tx-solr')) {
            return false;
        }

        self.go()
    }
    
    go() {
        
        $(document).ready(function () {
            let tx_solr_search = $("#tx-solr-search");

            //open mobile filter
            $("#tx-solr-show-filter a").click(function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (!tx_solr_search.hasClass("show_filter")) {
                    tx_solr_search.addClass("show_filter");
                }
            });

            //close mobile filter
            $("#tx-solr-close-filter").click(function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (tx_solr_search.hasClass("show_filter")) {
                    tx_solr_search.removeClass("show_filter");
                }
            });

            //open and close options filter
            $(".facet-show-list").click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (!$(this).parent().hasClass("facet-pageHierarchy") && $(window).width() > 768) {
                    $(this).toggleClass("open").next().slideToggle("250");
                }
            });

            $("#tx-solr-faceting .facet-pageHierarchy .facet-option-list > li > a").click(function (event) {
                // measure where click in button
                let positionX = event.pageX;
                let widthButton = $(this).width() * 0.7;
                let offsetLeftButton = $(this).offset().left;
                let positionInButton = (positionX - offsetLeftButton);

                // if click in link, go to the link
                if (positionInButton < widthButton) {
                    return true;
                }
                // if click in arrow, open this menu
                else {
                    event.preventDefault();
                    event.stopPropagation();
                    $(this).toggleClass("open").next().slideToggle("250");
                    return false;
                }

            });

            $("#tx-solr-faceting .facet-option-list > li > a + ul > li > a").click(function (event) {
                // measure where click in button
                let positionX = event.pageX;
                let widthButton = $(this).width() * 0.7;
                let offsetLeftButton = $(this).offset().left;
                let positionInButton = (positionX - offsetLeftButton);

                // if click in link, go to the link
                if (positionInButton < widthButton) {
                    return true;
                }
                // if click in arrow, open this menu
                else {
                    event.preventDefault();
                    event.stopPropagation();
                    $(this).toggleClass("open").next().slideToggle("250");
                    return false;
                }
            });

            $("#tx-solr-show-all").click(function () {
                $(".facet-show-list:not(.open)").trigger("click");
                $("#tx-solr-faceting .facet-pageHierarchy .facet-option-list > li > a:not(.open)").trigger("click");
                $(this).addClass("close");
                $("#tx-solr-close-all").addClass("open");
            });
            $("#tx-solr-close-all").click(function () {
                $(".facet-show-list").trigger("click");
                $("#tx-solr-faceting .facet-pageHierarchy .facet-option-list > li > a").trigger("click");
                $("#tx-solr-show-all").removeClass("close");
                $(this).removeClass("open");
            });


            // make year facet checkboxes trigger a new search
            $('.solr__result__facet__checkbox').click(function (event) {

                //console.log('solr facet checkbox clicked');

                // let's grab the URL from the EXT:solr generated link tag, which we hide...
                let solrFacetUrl = $(this).parent().find('.solr__result__facet__url-helper a').attr('href');
                //console.log('solrFacetUrl: ' + solrFacetUrl);

                // ...and call the url!
                window.location = solrFacetUrl;

            });

            // event scroll 
            $(window).scroll(function () {
                if ($(this).scrollTop() > 10) {
                    $(".tx-solr-search-form").addClass("scroll");
                } else {
                    $(".tx-solr-search-form").removeClass("scroll");
                }
            });

            // if click slimmenu, desactive the scticky form
            $(".collapse-button").click(function () {
                $(".tx-solr-search-form").toggleClass("show_slimmenu");
            });

            // let's active fewer options year
            let options_year = $(".facet-contentCreationYear .facet-option-list .facet-option");
            options_year.each(function (index, element) {
                if (index > 2) {
                    $(element).addClass("tx-solr-facet-hidden").hide();
                }
            });

            if (options_year.length > 3) {
                if (options_year.parent().find(".tx-solr-facet-show-all").length == 0)
                    options_year.parent().append('<li><a href="#" class="tx-solr-facet-show-all">Mehr zeigen</a></li>');
            }

            let options_files = $(".facet-fileExtension .facet-option-list .facet-option");
            options_files.each(function (index, element) {
                if (index > 2) {
                    $(element).addClass("tx-solr-facet-hidden").hide();
                }
            });

            if (options_files.length > 3) {
                options_files.parent().append('<li><a href="#" class="tx-solr-facet-show-all">Mehr zeigen</a></li>');
            }

            // if an option is active, let open that list of filter.
            let checkbox_filter = $(".facet-item");
            checkbox_filter.each(function (index, element) {
                if ($(this).attr('checked')) {

                    $(this).parents(".facet-option-list").show();
                    $(this).parents(".facet-option-list").prev().addClass("open");

                    if ($(this).parents(".facet-option").hasClass("tx-solr-facet-hidden")) {
                        //$(this).parents(".facet-option-list").find('.tx-solr-facet-hidden').show();
                        //$(".tx-solr-facet-show-all").trigger("click");
                    }
                    //console.log("Index: " + index);
                }
            });

            let active_options = $("#tx-solr-facets-active-options li > a");
            let bereich_options = $(".facet-pageHierarchy a");

            active_options.each(function (index_1, element_1) {
                let data = $(element_1).html();
                let text_filter = data.split(" ");

                bereich_options.each(function (index_2, element_2) {
                    if (!$(element_2).hasClass("open")) {
                        let bereich_data = $(element_2).html();
                        let bereich_filter = bereich_data.split(" ");

                        if (text_filter[1] == bereich_filter[0]) {
                            // console.log("Bereich: " + bereich_filter[0] );
                            bereich_options.trigger("click");
                            return false;
                        }
                    } else {
                        return false;
                    }
                });
            });
            let sortieren_option = $(".tx-solr-sorting-list img");

            if (sortieren_option.length >= 1) {
                $("#tx-solr-sorting .facet-show-list").trigger("click");
                $("#tx-solr-sorting .tx-solr-sorting-list li:first-child").addClass("desactive");
            } else {
                $("#tx-solr-sorting .facet-show-list").trigger("click");
            }
        });

    }
}
